import { useEffect } from 'react';
import { useTokenizedCardsStore } from './useTokenizedCardsStore';

export function useTokenizedCards() {
	const store = useTokenizedCardsStore();

	useEffect(() => {
		store.load();
	}, [store]);

	const { cards, isLoading } = store;
	const hasCards = cards.length > 0;

	return {
		hasCards,
		cards,
		isLoading,
	};
}
